import { functions } from "@/main";
import {
  MiraException,
  MiraExceptionSave,
  MiraExceptionSuggestion,
  MiraExceptionSuggestionDismissal,
} from "../models/MiraExceptionAdministration";

/**
 * Mira-Ausnahmen in the IRES Admin Client, through IRES Cloud (`MiraExceptionsForAdministration.ts`,
 * documented in Cloud `functions/docs/analytics/mira-precompute.md`). Each callable has a `…Development`
 * twin; swap to it **locally only** to drive the twin from a dev server, never commit the swap.
 */
const LIST_CALLABLE = "listMiraExceptionsForAdministration";
const SAVE_CALLABLE = "saveMiraExceptionForAdministration";
const LIST_SUGGESTIONS_CALLABLE = "listMiraExceptionSuggestionsForAdministration";
const DISMISS_SUGGESTION_CALLABLE = "dismissMiraExceptionSuggestionForAdministration";

/** Every entry, retired ones included. `MANAGE_CLIENTS`. */
export async function listMiraExceptions(): Promise<MiraException[]> {
  const data = (await functions.httpsCallable(LIST_CALLABLE)()).data as { exceptions?: unknown } | null;
  return Array.isArray(data?.exceptions) ? (data?.exceptions as MiraException[]) : [];
}

/** Creates or changes one entry. Rejects with `details.reason` (CHANGED_MEANWHILE, NO_CLIENT, INVALID_RANGE, ...). */
export async function saveMiraException(save: MiraExceptionSave): Promise<MiraException> {
  const data = (await functions.httpsCallable(SAVE_CALLABLE)(save)).data as { exception?: MiraException } | null;
  if (!data?.exception) {
    throw new Error("The save response carried no exception.");
  }
  return data.exception;
}

/** The open suggestions Mira found overnight (R8 Phase 3). `MANAGE_CLIENTS`. */
export async function listMiraExceptionSuggestions(): Promise<MiraExceptionSuggestion[]> {
  const data = (await functions.httpsCallable(LIST_SUGGESTIONS_CALLABLE)()).data as { suggestions?: unknown } | null;
  return Array.isArray(data?.suggestions) ? (data?.suggestions as MiraExceptionSuggestion[]) : [];
}

/** Dismisses one suggestion. Rejects with `details.reason` (NO_SUGGESTION, CHANGED_MEANWHILE, INVALID_REASON). */
export async function dismissMiraExceptionSuggestion(dismissal: MiraExceptionSuggestionDismissal): Promise<void> {
  await functions.httpsCallable(DISMISS_SUGGESTION_CALLABLE)(dismissal);
}
